export default __webpack_public_path__ + "static/media/creditCardIcon.5766663d.svg";